// extracted by mini-css-extract-plugin
export default {"cardCover":"Dashboard_cardCover__gQ005"};